export default import.meta.ROLLDOWN_FILE_URL_fZcsBtKRLAnew$MzpXDvvw